import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TasksBook from './TasksBook';
import AnalysePage from './AnalysePage';
import MetricsPage from './MetricsPage';

const Tasks = ({ match }) => {
   return (
      <Switch>
         <Route path={`${match.url}/logbook`} component={TasksBook} />
         <Route path={`${match.url}/metrics`} component={MetricsPage} />
         <Route path={`${match.url}/analyse`} component={AnalysePage} />
         <Route exact path={match.url} component={TasksBook} />
      </Switch>
   );
};

export default Tasks;
